// extracted by mini-css-extract-plugin
export default {"ComparedItem":"ComparedItem_ComparedItem__-XJ9f","missing":"ComparedItem_missing__xpwoO","loader":"ComparedItem_loader__9hfIr","load4":"ComparedItem_load4__6LIBW"};